const moduleLinks = [
  { label: '漫画索引', href: '#index' },
  { label: '焦点专题', href: '#carousel' },
  { label: '漫画热度排行榜', href: '#ranking' },
  { label: '漫画分类大全', href: '#cards' },
  { label: '最新动态', href: '#updates' },
  { label: '热门话题', href: '#topics' },
];

const partnerLinks = [
  { label: '合作伙伴A', href: '#' },
  { label: '合作伙伴B', href: '#' },
  { label: '合作伙伴C', href: '#' },
  { label: '合作伙伴D', href: '#' },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 pt-14 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div>
            <a href="#hero" className="font-heading text-xl text-background-50 no-underline">
              土豪漫画网
            </a>
            <p className="text-xs text-background-400 leading-relaxed mt-3 max-w-xs">
              专注<strong className="text-background-200">韩漫推荐</strong>、<strong className="text-background-200">日漫大全</strong>与<strong className="text-background-200">国漫排行榜</strong>的漫画分类阅读平台。
              以精准<strong className="text-background-200">漫画分类</strong>和每日同步更新，为漫画爱好者提供发现<strong className="text-background-200">好看的漫画</strong>的最佳入口。
            </p>
          </div>

          <div>
            <h4 className="font-serif font-semibold text-sm text-background-100 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              {moduleLinks.slice(0, 3).map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap no-underline"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-serif font-semibold text-sm text-background-100 mb-4">更多内容</h4>
            <nav className="flex flex-col gap-2">
              {moduleLinks.slice(3).map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap no-underline"
                >
                  {link.label}
                </a>
              ))}
              <a href="#about" className="text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap no-underline">关于我们</a>
              <a href="#faq" className="text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap no-underline">常见问答</a>
              <a href="#contact" className="text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap no-underline">联系我们</a>
            </nav>
          </div>

          <div>
            <h4 className="font-serif font-semibold text-sm text-background-100 mb-4">合作伙伴</h4>
            <nav className="flex flex-col gap-2">
              {partnerLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-xs text-background-400 hover:text-background-100 transition-colors whitespace-nowrap no-underline"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="border-t border-background-700/40 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 土豪漫画网. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-200 transition-colors no-underline">首页</a>
            <a href="#about" className="text-xs text-background-500 hover:text-background-200 transition-colors no-underline">关于</a>
            <a href="#contact" className="text-xs text-background-500 hover:text-background-200 transition-colors no-underline">联系</a>
          </div>
        </div>
      </div>
    </footer>
  );
}